import React, { Fragment, useState } from "react";
import { Button, Alert } from 'react-bootstrap';
import FuncionarioService from "../../../../services/funcionarios";


const Holerite = (props) => {
    const [error, setError] = useState(null)
    const func = JSON.parse(localStorage.getItem('funcionario'))
    const nomeMes = [
        "",            // índice 0 (não usado)
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
        "13º Salário - 1ª Parcela",
        "13º Salário - 2ª Parcela",
        "Informe Anual de Rendimentos"
    ];
    const handleDownload = async () => {
        try {
            const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

            var funcId = func._id;
            const response = await FuncionarioService.downloadHolerite(
                funcId,
                props.holerite._id
            );

            const filename = response.filename || "holerite.pdf";

            if (isIOS) {
                // 📱 iOS → Abrir via Base64
                const pdfUrl = `data:application/pdf;base64,${response.base64}`;
                window.open(pdfUrl, "_blank");
                return;
            }

            // 🖥️ Desktop / Android → Blob normal
            const uint8 = new Uint8Array(response.buffer);
            const blob = new Blob([uint8], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank");

        } catch (err) {
            const msg = err?.response?.data?.erro || err?.message || err || "Erro desconhecido";
            setError(msg);
            setTimeout(() => {
                window.confirm(err);
            }, 50);
        }
    };
    return (
        <Fragment>
            <tr>
                <td>
                    {nomeMes[props.holerite.mes]}/{props.holerite.ano}
                </td>
                <td style={{ whiteSpace: "nowrap" }}>
                    <Button variant="warning" type="button" onClick={handleDownload}>VER HOLERITE</Button>
                </td>

            </tr>
            {error && (
                <tr>
                    <td colSpan={2}>
                        <Alert variant="danger">{error}</Alert>
                    </td>
                </tr>
            )}

        </Fragment >)
}

export default Holerite;